
import { __ } from 'bits/intl'
import { Component, namespace, Prop, Vue } from 'bits/vue'
import BaseButtonIcon from 'library/v4/components/base-button-icon.vue'
import BaseIcon from 'vuecomponents/base_icon.vue'
import KeyboardTrapMixin from 'vuemixins/modal_keyboard_trap_mixin'

const browser = namespace('browser')
const EXTENSION_URL = 'https://chrome.google.com/webstore/detail/padlet-mini/kcljbbiddpoeaknnjaminoceoojdbikp'

@Component({
  components: {
    BaseIcon,
    BaseButtonIcon,
  },
  mixins: [KeyboardTrapMixin],
})
export default class Dropdown extends Vue {
  @Prop() title!: string
  @Prop() items!: Record<string, any>[]
  @browser.State os
  chromeExtensionUrl = EXTENSION_URL
  openModal!: (modalNodes: NodeList | Node[]) => void // from KeyboardTrapMixin
  closeModal!: () => void // from KeyboardTrapMixin
  isModalOpen!: boolean // from KeyboardTrapMixin

  handleMenu(): void {
    // find menu and its focusable children
    const menu = document.querySelector('.sub-menu') as HTMLElement
    const focusableElementsString = 'a'
    let menuNodes: NodeList | Node[] = menu.querySelectorAll(focusableElementsString)
    menuNodes = Array.from(menuNodes)

    this.openModal(menuNodes)
  }

  get backdropClass(): object {
    return {
      'dropdown-backdrop': this.isModalOpen,
    }
  }

  get menuClass(): object {
    return {
      show: this.isModalOpen,
      'sub-menu': true,
    }
  }

  get moreButtonLabel(): string {
    return __('More links')
  }

  get isOsSupported(): boolean {
    return this.os !== 'unknown'
  }

  get installAppUrl(): string | undefined {
    if (this.os === 'ios') return 'https://padlet.com/ios-app'
    if (this.os === 'android') return 'https://padlet.com/android-app'
    if (this.os === 'windows') return 'https://www.microsoft.com/en-us/p/padlet/9mtwd1kmhb48'
    if (this.os === 'mac') return 'https://padlet.com/mac-app-download'
    return undefined
  }

  get installAppText(): string | undefined {
    if (this.os === 'ios') return __('Install iOS app')
    if (this.os === 'android') return __('Install android app')
    if (this.os === 'windows') return __('Install windows app')
    if (this.os === 'mac') return __('Install mac app')
    return undefined
  }
}
